import React from 'react';
import { GraduationCap, Award, BookOpen } from 'lucide-react';

const FormationsSection = () => {
  const formations = [
    {
      title: 'Certificação Internacional de Terapeuta Especializada em Terapia de Reprocessamento Generativo',
      hours: '360 horas',
      institution: 'UNIFATEC',
      type: 'completed'
    },
    {
      title: 'Certificação Internacional de Especialista em Leitura Corporal e Comportamental',
      hours: '40 horas',
      institution: 'IBFT + IETRG',
      type: 'completed'
    },
    {
      title: 'Certificação de Terapeuta em Relacionamento e Sexualidade',
      hours: '74 horas',
      institution: 'Faculdade de Brasília - FBr',
      type: 'completed'
    },
    {
      title: 'Psicanálise TEA e TDAH',
      hours: '8 horas',
      institution: 'Instituto Andréa Vermont',
      type: 'completed'
    },
    {
      title: 'Neurociência e Psicanálise',
      hours: 'Em andamento',
      institution: '',
      type: 'ongoing'
    }
  ];

  return (
    <section id="formacoes" className="py-24 bg-gradient-to-b from-blue-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">Formações e Certificações</h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full mb-6"></div>
            <p className="text-xl text-gray-600">
              Capacitação contínua para oferecer o melhor atendimento
            </p>
          </div>

          <div className="space-y-6">
            {formations.map((formation, index) => (
              <div
                key={index}
                className="bg-white p-6 md:p-8 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-blue-100 hover:border-blue-300"
              >
                <div className="flex items-start gap-6">
                  <div className="bg-blue-100 p-4 rounded-full flex-shrink-0">
                    {formation.type === 'completed' ? (
                      <Award className="text-blue-600" size={28} />
                    ) : (
                      <BookOpen className="text-blue-600" size={28} />
                    )}
                  </div>
                  <div className="flex-1">
                    <div className="flex flex-wrap items-start justify-between gap-4 mb-2">
                      <h3 className="text-xl font-bold text-blue-900 flex-1">
                        {formation.title}
                      </h3>
                      {formation.type === 'ongoing' && (
                        <span className="bg-blue-100 text-blue-700 px-4 py-1 rounded-full text-sm font-semibold">
                          Em andamento
                        </span>
                      )}
                    </div>
                    <div className="flex flex-wrap gap-4 text-gray-600">
                      {formation.hours && (
                        <span className="flex items-center gap-2">
                          <GraduationCap size={18} className="text-blue-600" />
                          {formation.hours}
                        </span>
                      )}
                      {formation.institution && (
                        <span className="text-gray-700 font-medium">
                          {formation.institution}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center px-4">
            <div className="inline-flex flex-col md:flex-row items-center gap-4 md:gap-8 bg-blue-600 text-white px-8 md:px-16 py-6 md:py-5 rounded-2xl shadow-xl max-w-2xl">
              <img 
                src="https://customer-assets.emergentagent.com/job_6ecc521e-0167-467f-95d1-01468e73454b/artifacts/88b57n71_Selo%20terapeuta%20certificado%20TRG_fundos%20escuros.png"
                alt="Terapeuta Certificado TRG"
                className="w-24 h-24 md:w-28 md:h-28"
                loading="eager"
                style={{ imageRendering: 'high-quality' }}
              />
              <div className="text-center md:text-left">
                <p className="text-xs md:text-sm text-blue-200 mb-1">Registro Profissional</p>
                <p className="font-bold text-2xl md:text-3xl">CITRG Nº 11.491</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormationsSection;